import { DateTime } from 'luxon'

export function formatRelativeDate(input, locale, formatMessage) {
  const now = DateTime.now().setLocale(locale)

  const date =
    typeof input === 'string'
      ? DateTime.fromISO(input).setLocale(locale)
      : input.setLocale(locale)

  const diffInMinutes = now.diff(date, 'minutes').minutes
  const diffInDays = now.startOf('day').diff(date.startOf('day'), 'days').days

  const isGerman = locale.startsWith('de')

  const formatTime = () => {
    const time = date.toLocaleString({
      hour: '2-digit',
      minute: '2-digit'
    })

    return isGerman ? `${time} Uhr` : time
  }

  // JUST NOW
  if (diffInMinutes < 1) {
    return formatMessage({ id: 'just_now' })
  }

  // TODAY
  if (diffInDays === 0) {
    return formatTime()
  }

  // YESTERDAY
  if (diffInDays === 1) {
    const label = formatMessage({ id: 'yesterday' })
    return `${label}, ${formatTime()}`
  }

  // THIS WEEK
  if (date.hasSame(now, 'week')) {
    const weekday = date.toLocaleString({ weekday: 'long' })
    return `${weekday}, ${formatTime()}`
  }

  // OLDER (custom format)
  if (!isGerman) {
    return date.toFormat('dd LLL yy')
  }

  if (isGerman) {
    return date.toFormat('d.M.yyyy')
  }

  return date.toLocaleString(DateTime.DATE_SHORT)
}
